var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.21 66.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aaceefbe-9edd-457b-a14b-aa2a93a7b79b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:8px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8D44\u6E90 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aa1688c8-b952-454b-a598-b80d8555cb8c",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a9ca9cf2-e5ca-4d80-ba80-f52dd42f6f8e",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aaceefbe-9edd-457b-a14b-aa2a93a7b79b",
    d: "M18.13,56.73A28.31,28.31,0,0,1,7.53,45.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aaceefbe-9edd-457b-a14b-aa2a93a7b79b",
    d: "M7.53,18.57A28.45,28.45,0,0,1,18.13,7.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aaceefbe-9edd-457b-a14b-aa2a93a7b79b",
    d: "M60.51,32.26A28.26,28.26,0,0,0,18.13,7.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aaceefbe-9edd-457b-a14b-aa2a93a7b79b",
    d: "M28.73,18.57A14.16,14.16,0,0,1,46.39,32.26a13.86,13.86,0,0,1-.32,3L56.91,46.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aaceefbe-9edd-457b-a14b-aa2a93a7b79b",
    d: "M28.73,45.94a14.13,14.13,0,0,1,0-27.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aaceefbe-9edd-457b-a14b-aa2a93a7b79b",
    d: "M7.53,45.94a28.29,28.29,0,0,1,0-27.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aaceefbe-9edd-457b-a14b-aa2a93a7b79b",
    d: "M18.13,56.73a28.29,28.29,0,0,0,29-.45l4.42,4.41,10-10-4.64-4.63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg03);
export default __webpack_public_path__ + "static/media/bg-03.68d1cf4db22dc2b7a8a613ee43ee5971.svg";
export { ForwardRef as ReactComponent };